import {
    Brightness4,
    Brightness7,
    PhotoCamera,
    WorkspacePremium
} from '@mui/icons-material';
import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Badge, Box, Button, IconButton, Menu, MenuItem, Switch, Toolbar, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PremiumFeatureBadge from './PremiumFeatureBadge';
import { resolvePublicMediaUrl } from '../helpers/formatters';
import { hasPremiumAccess, PREMIUM_FEATURE_TOOLTIP, readStoredPlanName } from '../helpers/subscription';

const Header = ({ toggleSidebar, toggleDarkMode, darkMode }) => {
    const [userName, setUserName] = useState('');
    const [userEmail, setUserEmail] = useState('');
    const [storeName, setStoreName] = useState('');
    const [profilePicture, setProfilePicture] = useState('');
    const [anchorEl, setAnchorEl] = useState(null);  // Controla o estado do menu
    const openMenu = Boolean(anchorEl);  // Verifica se o menu está aberto
    const navigate = useNavigate();

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);  // Abre o menu quando clicar no ícone
    };
    const handleMenuClose = () => {
        setAnchorEl(null);  // Fecha o menu
    };
    const handleMenuMyAccount = () => {
        setAnchorEl(null);
        navigate('/admin/my-account');
    };
    const handleMenuIntegrations = () => {
        setAnchorEl(null);
        navigate('/admin/integrations');
    };
    const handleMenuSalesChannels = () => {
        setAnchorEl(null);
        navigate('/admin/sales-channels');
    };
    const handleMenuPaymentFees = () => {
        setAnchorEl(null);
        navigate('/admin/payment-fees');
    };

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            let user = JSON.parse(storedUser);
            setUserName(user.name ?? '');
            setUserEmail(user.email ?? '');
            setStoreName(user.store_name ?? '');
            setProfilePicture(user.profile_picture);
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('access_token');
        console.log("Saindo...");
        window.location.href = '/admin/login';
        handleMenuClose();
    };

    const getInitials = (name, email) => {
        const trimmed = typeof name === 'string' ? name.trim() : '';
        if (trimmed !== '') {
            const parts = trimmed.split(/\s+/).filter(Boolean);
            const first = parts[0]?.charAt(0).toUpperCase() ?? '';
            const second = parts.length > 1 ? parts[1].charAt(0).toUpperCase() : '';
            return (first + second) || '?';
        }
        const mail = typeof email === 'string' ? email.trim() : '';
        if (mail !== '') {
            return mail.charAt(0).toUpperCase();
        }
        return '?';
    };

    const location = useLocation();
    const hasPremium = hasPremiumAccess(readStoredPlanName());

    return (
        <AppBar position="sticky" sx={{ zIndex: 1201 }}>
            <Toolbar>
                <IconButton edge="start" color="inherit" onClick={toggleSidebar}>
                    <MenuIcon />
                </IconButton>

                <Typography
                    variant="h6"
                    component="a"
                    href="/"
                    onClick={(e) => {
                        e.preventDefault();
                        window.location.href = '/admin';
                    }}
                    sx={{
                        flexGrow: 1,
                        fontFamily: '"Curitiba", sans-serif',
                        fontWeight: 'lighter',
                        letterSpacing: "1px",
                        textDecoration: "none", // Remove sublinhado padrão do link
                        color: "inherit", // Mantém a cor do tema
                        cursor: "pointer", // Indica que é clicável
                    }}
                >
                    ACOMPANHA 3D
                </Typography>

                {/* Itens de navegação no Header */}
                <Box sx={{ display: { xs: 'none', md: 'flex' }, flexDirection: 'row', alignItems: 'center', mr: 3 }}>
                    {/*<Button*/}
                    {/*    color={location.pathname === '/admin' ? 'primary' : 'inherit'} // Destaca o item ativo*/}
                    {/*    component={Link}*/}
                    {/*    to="/admin"*/}
                    {/*    startIcon={<DashboardIcon/>}*/}
                    {/*    sx={{*/}
                    {/*        mr: 3,*/}
                    {/*        color: location.pathname === '/admin' ? (darkMode ? 'yellow' : 'blue') : 'inherit'  // Cor personalizada no modo claro e escuro*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    Dashboard*/}
                    {/*</Button>*/}
                    {/*<Button*/}
                    {/*    color={location.pathname === '/admin/printers' ? 'primary' : 'inherit'}*/}
                    {/*    component={Link}*/}
                    {/*    to="/admin/printers"*/}
                    {/*    startIcon={<PrinterIcon/>}*/}
                    {/*    sx={{*/}
                    {/*        mr: 3,*/}
                    {/*        color: (*/}
                    {/*            location.pathname === '/admin/printers' ||*/}
                    {/*            location.pathname === '/admin/register-printer' ||*/}
                    {/*            /^\/admin\/edit-printer\/[^/]+$/.test(location.pathname)  // Verifica se a rota corresponde a '/edit-printer/:id'*/}
                    {/*        ) ? (darkMode ? 'yellow' : 'blue') : 'inherit'*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    Impressoras*/}
                    {/*</Button>*/}
                    {/*<Button*/}
                    {/*    color={location.pathname === '/admin/materials' ? 'primary' : 'inherit'}*/}
                    {/*    component={Link}*/}
                    {/*    to="/admin/materials"*/}
                    {/*    startIcon={<Widgets/>}*/}
                    {/*    sx={{*/}
                    {/*        mr: 3,*/}
                    {/*        color: (*/}
                    {/*            location.pathname === '/admin/materials' ||*/}
                    {/*            location.pathname === '/admin/register-material' ||*/}
                    {/*            /^\/admin\/edit-material\/[^/]+$/.test(location.pathname)  // Verifica se a rota corresponde a '/edit-printer/:id'*/}
                    {/*        ) ? (darkMode ? 'yellow' : 'blue') : 'inherit'*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    Materiais e Acessórios*/}
                    {/*</Button>*/}
                    {/*<Button*/}
                    {/*    color={location.pathname === '/admin/products' ? 'primary' : 'inherit'}*/}
                    {/*    component={Link}*/}
                    {/*    to="/admin/products"*/}
                    {/*    startIcon={<StorefrontIcon/>}*/}
                    {/*    sx={{*/}
                    {/*        mr: 3,*/}
                    {/*        color: location.pathname === '/admin/products' ? (darkMode ? 'yellow' : 'blue') : 'inherit'*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    Produtos*/}
                    {/*</Button>*/}

                    {/*<Button*/}
                    {/*    color={location.pathname === '/admin/calculator' ? 'primary' : 'inherit'}*/}
                    {/*    component={Link}*/}
                    {/*    to="/admin/calculator"*/}
                    {/*    startIcon={<CalculateOutlined />}*/}
                    {/*    sx={{*/}
                    {/*        mr: 3,*/}
                    {/*        color: location.pathname === '/admin/calculator' ? (darkMode ? 'yellow' : 'blue') : 'inherit'*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    Calculadora de preço*/}
                    {/*</Button>*/}
                    {/*<Button*/}
                    {/*    color={location.pathname === '/admin/checkouts' ? 'primary' : 'inherit'}*/}
                    {/*    component={Link}*/}
                    {/*    to="/admin/checkouts"*/}
                    {/*    startIcon={<ShoppingCart/>}*/}
                    {/*    sx={{*/}
                    {/*        mr: 3,*/}
                    {/*        color: location.pathname === '/admin/checkouts' ? (darkMode ? 'yellow' : 'blue') : 'inherit'*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    Vendas em andamento*/}
                    {/*</Button>*/}
                    {hasPremium ? (
                        <Button
                            component={Link}
                            to="/admin/quick-checkout"
                            startIcon={<PhotoCamera />}
                            endIcon={<PremiumFeatureBadge sx={{ ml: 0 }} />}
                            sx={{
                                mr: 3,
                                color: location.pathname === '/admin/quick-checkout' ? (darkMode ? 'yellow' : 'white') : 'inherit'
                            }}
                        >
                            Quick Checkout
                        </Button>
                    ) : (
                        <Tooltip title={PREMIUM_FEATURE_TOOLTIP} arrow>
                            <Button
                                disabled
                                startIcon={<PhotoCamera />}
                                endIcon={<PremiumFeatureBadge sx={{ ml: 0 }} />}
                                sx={{
                                    mr: 3,
                                    color: 'inherit',
                                    opacity: 0.72,
                                }}
                            >
                                Quick Checkout
                            </Button>
                        </Tooltip>
                    )}
                </Box>


                {/* Mobile: Apenas ícone do Quick Checkout */}
                <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center' }}>
                    {hasPremium ? (
                        <Tooltip title="Quick Checkout" arrow>
                            <IconButton
                                component={Link}
                                to="/admin/quick-checkout"
                                sx={{
                                    color: location.pathname === '/admin/quick-checkout' ? (darkMode ? 'yellow' : 'white') : 'inherit'
                                }}
                            >
                                <Badge
                                    overlap="circular"
                                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                    badgeContent={<WorkspacePremium sx={{ fontSize: 14, color: 'warning.main' }} />}
                                >
                                    <PhotoCamera />
                                </Badge>
                            </IconButton>
                        </Tooltip>
                    ) : (
                        <Tooltip title={PREMIUM_FEATURE_TOOLTIP} arrow>
                            <span>
                                <IconButton disabled sx={{ color: 'inherit', opacity: 0.72 }}>
                                    <Badge
                                        overlap="circular"
                                        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                                        badgeContent={<WorkspacePremium sx={{ fontSize: 14, color: 'warning.main' }} />}
                                    >
                                        <PhotoCamera />
                                    </Badge>
                                </IconButton>
                            </span>
                        </Tooltip>
                    )}
                </Box>

                <IconButton color="inherit" onClick={handleMenuOpen}>
                    {profilePicture ? (
                        <img
                            src={resolvePublicMediaUrl(profilePicture)}
                            alt="Foto de Perfil"
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                objectFit: 'cover', // Garante que a imagem cubra toda a área
                            }}
                        />
                    ) : (
                        <div
                            style={{
                                width: '40px',
                                height: '40px',
                                borderRadius: '50%',
                                backgroundColor: 'rgba(241, 39, 17, 0.8)',
                                color: 'white',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontWeight: 'bold',
                                fontSize: '18px',
                            }}
                        >
                            {getInitials(userName, userEmail)}
                        </div>
                    )}
                </IconButton>

                {/* Menu suspenso */}
                <Menu
                    anchorEl={anchorEl}  // Posição do menu
                    open={openMenu}  // Condição de abertura
                    onClose={handleMenuClose}  // Fecha o menu ao clicar fora ou nas opções
                >
                    <MenuItem onClick={handleMenuClose}>Olá, {userName}</MenuItem> {/* Exibe o nome */}
                    <MenuItem onClick={handleMenuMyAccount}>Minha Conta</MenuItem>
                    <MenuItem onClick={handleMenuSalesChannels}>Canais de vendas</MenuItem>
                    <MenuItem onClick={handleMenuPaymentFees}>Taxas da maquininha</MenuItem>
                    <MenuItem onClick={handleMenuIntegrations}>Integrações</MenuItem>

                    {/* Switch de tema dentro do menu (desktop e mobile) */}
                    <MenuItem sx={{ justifyContent: 'space-between', minWidth: '200px' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                            {darkMode ? <Brightness4 /> : <Brightness7 />}
                            <Typography sx={{ ml: 1 }}>
                                {darkMode ? 'Modo Claro' : 'Modo Escuro'}
                            </Typography>
                        </Box>
                        <Switch
                            checked={darkMode}
                            onChange={toggleDarkMode}
                            name="darkMode"
                            color="default"
                            inputProps={{ 'aria-label': 'dark mode toggle' }}
                        />
                    </MenuItem>

                    {/*<MenuItem onClick={handleMenuClose}>Configurações</MenuItem>*/}
                    <MenuItem onClick={handleLogout}>Sair</MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    );
};

export default Header;
